import { mutate as globalMutate } from "swr";

let redirectScheduled = false;

const LOGIN_PATHS = ["/", "/login"];

const AUTH_ME_PATH = "/api/v1/auth/me";

/** Clear token, auth context, and cached /auth/me (SPA logout without full reload). */
export function clearAuthSession(setUserMe) {
  try {
    localStorage.removeItem("token");
  } catch {
    /* ignore */
  }

  setUserMe?.(null);

  void globalMutate((key) => typeof key === "object" && key?.path === AUTH_ME_PATH, undefined, { revalidate: false });
}

export function isLoginRoutePathname(pathname) {
  return LOGIN_PATHS.includes(pathname);
}

/** Clear token and hard-redirect to login (resets SWR / React state). */
export function logoutExpiredSession() {
  if (typeof window === "undefined") return;

  try {
    localStorage.removeItem("token");
  } catch {
    /* ignore */
  }

  const pathname = window.location.pathname || "/";
  if (isLoginRoutePathname(pathname)) {
    return;
  }

  if (redirectScheduled) return;
  redirectScheduled = true;
  window.location.assign("/");
}
